import { createFileRoute } from "@tanstack/react-router";

import { SettingsAccountSecurity } from "@/features/my/settings/account/security";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/security",
)({
  component: SettingsAccountSecurity,
});
